import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModuleTypes } from 'src/app/modules/settings/enums/moduleTypes';
import { EmployeeRoleTypes } from 'src/app/modules/shared/enums/employees/EmployeeRoleTypes';
import { Account } from 'src/app/modules/shared/models/account';
import { Employee } from 'src/app/modules/shared/models/employee';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { EmployeeUtil } from 'src/app/modules/shared/utilities/employee.utilities';
import { EmployeeDetailsViewModel } from 'src/app/modules/shared/viewModels/employeeDetailsViewModel';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-sustainability-employee-permissions',
    templateUrl: './sustainability-employee-permissions.component.html',
    styleUrls: ['./sustainability-employee-permissions.component.scss'],
    standalone: false
})
export class SustainabilityEmployeePermissionsComponent implements OnInit {
  @Input() employeeDetailsViewModel: EmployeeDetailsViewModel;
  @Input() isInPrimaryRole: boolean;
  @Input() isAccountAdmin: boolean;

  public readonly employeeRoleTypes = EmployeeRoleTypes;
  public readonly T = T;

  private account: Account;
  private employee: Employee;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.employee = this.authenticationService.getCurrentEmployee();
    this.account = this.authenticationService.getCurrentAccount();
  }

  selectSusUserRole(isAdd: boolean) {
    if (isAdd) {
      this.employeeDetailsViewModel.modulePermissionViewModels.push({
        employeeId: this.employeeDetailsViewModel.id,
        id: 0,
        module: ModuleTypes.Sustainability,
        objectType: 0,
        created: '',
        accountId: this.employee.accountId,
        createdById: this.employee.id
      });
    } else {
      this.employeeDetailsViewModel.modulePermissionViewModels = this.employeeDetailsViewModel.modulePermissionViewModels.filter(
        (r) => r.module != ModuleTypes.Sustainability
      );
    }

    this.changeDetectorRef.detectChanges();
  }

  hasAccessToModule() {
    return EmployeeUtil.hasAccessToModule(this.employeeDetailsViewModel, ModuleTypes.Sustainability);
  }
}
